import React, { useState, useEffect } from 'react';
import './AtributosData.css';
import baseURL from '../../url';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

export default function AtributosData() {
    const [conjuntos, setConjuntos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editando, setEditando] = useState(null);
    const [nombre, setNombre] = useState('');
    const [guardando, setGuardando] = useState(false);

    useEffect(() => { cargar(); }, []);

    const cargar = () => {
        setLoading(true);
        fetch(`${baseURL}/atributosGet.php`)
            .then(r => r.json())
            .then(d => setConjuntos(d.atributos || []))
            .catch(() => setConjuntos([]))
            .finally(() => setLoading(false));
    };

    const abrirNuevo = () => { setEditando(null); setNombre(''); setModalOpen(true); };
    const abrirEditar = (c) => { setEditando(c); setNombre(c.nombre); setModalOpen(true); };

    const guardar = async () => {
        if (!nombre.trim()) { toast.error('El nombre es obligatorio'); return; }
        setGuardando(true);
        const fd = new FormData();
        fd.append('nombre', nombre.trim());
        if (editando) fd.append('idAtributo', editando.idAtributo);
        const url = editando ? `${baseURL}/atributoUpdate.php` : `${baseURL}/atributoPost.php`;
        try {
            const res = await fetch(url, { method: 'POST', body: fd });
            const d = await res.json();
            if (d.mensaje) {
                toast.success(editando ? 'Actualizado ✅' : 'Creado ✅');
                setModalOpen(false);
                cargar();
            } else toast.error(d.error || 'Error');
        } catch { toast.error('Error de conexión'); }
        setGuardando(false);
    };

    const eliminar = (c) => {
        Swal.fire({
            title: `¿Eliminar "${c.nombre}"?`,
            icon: 'warning', showCancelButton: true,
            confirmButtonText: 'Eliminar', cancelButtonText: 'Cancelar',
            confirmButtonColor: '#e53935',
        }).then(async r => {
            if (!r.isConfirmed) return;
            const fd = new FormData();
            fd.append('idAtributo', c.idAtributo);
            const res = await fetch(`${baseURL}/atributoDelete.php`, { method: 'POST', body: fd });
            const d = await res.json();
            if (d.mensaje) { toast.success('Eliminado'); cargar(); }
            else toast.error(d.error || 'Error');
        });
    };

    return (
        <div className="atributosData">
            <ToastContainer />
            <div className="atributosHeader">
                <div>
                    <h2>📦 Conjuntos de Atributos</h2>
                    <p>Crea grupos de atributos como: Colores, Tallas, Materiales, etc.</p>
                </div>
                <button className="btnNuevoAtributo" onClick={abrirNuevo}>+ Nuevo conjunto</button>
            </div>

            {loading ? <div className="atributosLoading">Cargando...</div> :
                conjuntos.length === 0 ? (
                    <div className="atributosVacio">
                        <span>📦</span>
                        <p>No hay conjuntos de atributos. ¡Crea el primero!</p>
                    </div>
                ) : (
                    <div className="atributosTable">
                        <div className="atributosTableHead">
                            <span>#</span>
                            <span>Nombre del conjunto</span>
                            <span>Acciones</span>
                        </div>
                        {conjuntos.map((c, i) => (
                            <div className="atributosTableRow" key={c.idAtributo}>
                                <span className="rowNum">{i + 1}</span>
                                <span className="rowNombre">
                                    <strong>{c.nombre}</strong>
                                </span>
                                <div className="rowAcciones">
                                    <button className="btnEditar" onClick={() => abrirEditar(c)}>✏️ Editar</button>
                                    <button className="btnEliminar" onClick={() => eliminar(c)}>🗑️ Eliminar</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )
            }

            {modalOpen && (
                <div className="atribModalOverlay" onClick={() => setModalOpen(false)}>
                    <div className="atribModal" onClick={e => e.stopPropagation()}>
                        <div className="atribModalHeader">
                            <h3>{editando ? 'Editar conjunto' : 'Nuevo conjunto de atributos'}</h3>
                            <button onClick={() => setModalOpen(false)}>✕</button>
                        </div>
                        <div className="atribModalBody">
                            <label>Nombre del conjunto *</label>
                            <input
                                type="text"
                                value={nombre}
                                onChange={e => setNombre(e.target.value)}
                                placeholder="Ej: Colores, Tallas, Material..."
                                onKeyDown={e => e.key === 'Enter' && guardar()}
                                autoFocus
                            />
                            <p className="atribHint">Este nombre se verá al asociar atributos a un producto.</p>
                        </div>
                        <div className="atribModalFooter">
                            <button className="btnCancelar" onClick={() => setModalOpen(false)}>Cancelar</button>
                            <button className="btnGuardar" onClick={guardar} disabled={guardando}>
                                {guardando ? 'Guardando...' : editando ? 'Actualizar' : 'Crear conjunto'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
